<template>
	<div style="margin-top: 8px;">
		<el-tabs v-model="choosetitleindex" @tab-click="clickchoosetap" style="margin-left: 16px;">
			<el-tab-pane label="负数普票填开" name="0"></el-tab-pane>
			<el-tab-pane label="负数专票填开" name="1"></el-tab-pane>
		</el-tabs>
		<pupiao v-if="choosetitleindex == '0'"></pupiao>
		<zhuanpiao v-if="choosetitleindex == '1'"></zhuanpiao>
	</div>
</template>

<script>
import zhuanpiao from './FilloutZhuannegativeinvoice.vue';
import pupiao from './Filloutnegativeinvoice.vue';
export default {
	components: {
		zhuanpiao,
		pupiao
	},
	data() {
		return {
			headtitle: ['发票管理', '负数发票填开'],
			choosetitleindex: '0'
		};
	},
	created() {
		// this.getDocList()
	},
	mounted() {},
	methods: {}
};
</script>

<style>
/deep/.el-tabs__header {
	margin: 0 0 0px !important;
}
</style>
